import React from 'react';

const MethodsDecoration = () => (
  <svg
    width="434"
    height="368"
    viewBox="0 0 434 368"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M386.066 213.145V155.289H111.214V516.887H349.901"
      stroke="black"
      strokeMiterlimit="10"
    />
    <path
      d="M414.997 444.567H429.463V126.361L386.066 82.9692H176.31V130.7"
      stroke="#6B9CCC"
      strokeMiterlimit="10"
    />
    <path d="M386.066 225.439V237.734" stroke="black" strokeMiterlimit="10" />
    <path d="M386.066 249.305V516.887" stroke="black" strokeMiterlimit="10" />
    <path
      d="M386.066 82.9692V126.361H429.464"
      stroke="#6B9CCC"
      strokeMiterlimit="10"
    />
    <path d="M165.461 213.868H331.819" stroke="black" strokeMiterlimit="10" />
    <path d="M165.461 243.519H331.819" stroke="black" strokeMiterlimit="10" />
    <path d="M165.461 273.893H331.819" stroke="black" strokeMiterlimit="10" />
    <path d="M165.461 304.268H331.819" stroke="black" strokeMiterlimit="10" />
    <path d="M165.461 333.918H331.819" stroke="black" strokeMiterlimit="10" />
    <path d="M165.461 364.293H331.819" stroke="black" strokeMiterlimit="10" />
    <rect
      x="292.349"
      y="134.988"
      width="13.941"
      height="13.941"
      transform="rotate(180 292.349 134.988)"
      fill="#284F76"
    />
    <rect
      x="65.0498"
      y="151.128"
      width="13.941"
      height="13.941"
      transform="rotate(180 65.0498 151.128)"
      fill="#284F76"
    />
    <rect
      x="151.128"
      y="100.019"
      width="13.941"
      height="13.941"
      transform="rotate(180 151.128 100.019)"
      fill="#284F76"
    />
    <rect
      x="108.089"
      y="133.643"
      width="13.941"
      height="13.941"
      transform="rotate(180 108.089 133.643)"
      fill="#284F76"
    />
    <rect
      x="58.325"
      y="93.2944"
      width="13.941"
      height="13.941"
      transform="rotate(180 58.325 93.2944)"
      fill="#284F76"
    />
    <rect
      x="108.089"
      y="70.4292"
      width="13.941"
      height="13.941"
      transform="rotate(180 108.089 70.4292)"
      fill="#284F76"
    />
    <rect
      x="51.6001"
      y="231.826"
      width="13.941"
      height="13.941"
      transform="rotate(180 51.6001 231.826)"
      fill="#284F76"
    />
    <rect
      x="108.089"
      y="13.9409"
      width="13.941"
      height="13.941"
      transform="rotate(180 108.089 13.9409)"
      fill="#284F76"
    />
    <rect
      x="13.9409"
      y="65.0498"
      width="13.941"
      height="13.941"
      transform="rotate(180 13.9409 65.0498)"
      fill="#284F76"
    />
    <rect
      x="65.0498"
      y="47.5654"
      width="13.941"
      height="13.941"
      transform="rotate(180 65.0498 47.5654)"
      fill="#284F76"
    />
    <rect
      x="134.988"
      y="77.1543"
      width="13.941"
      height="13.941"
      transform="rotate(180 134.988 77.1543)"
      fill="#284F76"
    />
    <rect
      x="180.717"
      y="144.403"
      width="13.941"
      height="13.941"
      transform="rotate(180 180.717 144.403)"
      fill="#284F76"
    />
    <rect
      x="254.69"
      y="126.918"
      width="13.941"
      height="13.941"
      transform="rotate(180 254.69 126.918)"
      fill="#284F76"
    />
    <rect
      x="187.442"
      y="63.7051"
      width="13.941"
      height="13.941"
      transform="rotate(180 187.442 63.7051)"
      fill="#284F76"
    />
    <rect
      x="20.6658"
      y="120.193"
      width="13.941"
      height="13.941"
      transform="rotate(180 20.6658 120.193)"
      fill="#284F76"
    />
    <rect
      x="130.962"
      y="32.7793"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect x="0.5" y="26.0542" width="12.941" height="12.941" stroke="#6B9CCC" />
    <rect
      x="184.761"
      y="91.958"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="110.788"
      y="132.307"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="153.827"
      y="98.6826"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="203.59"
      y="134.997"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="252.009"
      y="59.6787"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="289.668"
      y="91.958"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="81.1982"
      y="67.7485"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="7.22485"
      y="105.408"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="74.4731"
      y="211.66"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="252.009"
      y="105.408"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="38.1592"
      y="145.757"
      width="12.941"
      height="12.941"
      stroke="#6B9CCC"
    />
    <rect
      x="230.481"
      y="74.4644"
      width="13.941"
      height="13.941"
      transform="rotate(180 230.481 74.4644)"
      fill="#284F76"
    />
  </svg>
);

export default MethodsDecoration;
